import React from 'react';

import { List } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { ToothNumberBox } from '../../../../../../common-components/composed/toothNumberBox/ToothNumberBox';
import { RADIOGRAPHIC_BONELOSS } from '../../../../../../constants';
import {
  blueBlack650,
  blueBlack700,
} from '../../../../../../theme/videa-style-tokens';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- 'theme' is defined but never used.
const useStyles = makeStyles((theme) => ({
  findingList: {
    margin: 0,
    padding: '1em 0em',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: blueBlack650,
    borderBottomColor: 'transparent',
  },
  listHeader: {
    display: 'flex',
    marginTop: '.5em',
    padding: '1em .5em 0.25em',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: blueBlack700,
    zIndex: 0,
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: blueBlack650,
    borderBottomColor: 'transparent',
  },
}));

const ToothNumberHeader = (props: PropTypes) => {
  const {
    children,
    toothNumber = 0,
    isFindingTypeVisible = false,
    isVideaDemoUser = false,
    findingGroup,
  } = props;

  const classes = useStyles();
  if (!isFindingTypeVisible) {
    return <></>;
  }

  return (
    <List
      aria-labelledby="nested-list-subheader"
      className={classes.findingList}
      subheader={
        (isVideaDemoUser || findingGroup.type === RADIOGRAPHIC_BONELOSS) && (
          <ToothNumberBox
            isFindingTypeVisible={isFindingTypeVisible}
            toothNumber={toothNumber}
          />
        )
      }
    >
      {children}
    </List>
  );
};

type PropTypes = {
  children: any;
  toothNumber: any;
  isFindingTypeVisible: boolean;
  isVideaDemoUser: boolean;
  updateToothNumber: () => void;
  findingGroup: any;
};

export default ToothNumberHeader;
